import $ from "jquery";

(async () => {

    const bind = async() => {
        const els =
            $(".dpl-property-grid");

        if (els.length > 0) {
            const f = await import(
                /* webpackChunkName : "propertyGrid" */
                './scripts/Client'
                );
            f.default();
        }
    };

    await bind();

    if( window.acf ) {
        window.acf.addAction(
            'render_block_preview',
            (el, ev) => {
                if(ev.name==='acf/property-grid') {
                    bind();
                }
            });
    }
})();